/* eslint-disable @typescript-eslint/ban-ts-comment */
import { SearchClient, SearchForHits } from 'algoliasearch';
import { liteClient as algoliasearch, SearchMethodParams, SearchQuery } from 'algoliasearch/lite';
import { ALGOLIA_APP_ID, ALGOLIA_APP_KEY, ALGOLIA_INDEX_NAME } from 'constants/algolia';

if (!ALGOLIA_APP_ID || !ALGOLIA_APP_KEY || !ALGOLIA_INDEX_NAME) {
  throw new Error('Algolia Application ID, API Key and Index must be defined in .env');
}

let hasSearched = false;
const algoliaClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_APP_KEY);

const searchClient: SearchClient = {
  ...algoliaClient,
  // @ts-ignore
  search(requests: SearchQuery[]) {
    const searchBarRequest = requests.find((request) => request.indexName === ALGOLIA_INDEX_NAME);
    // @ts-ignore
    if (searchBarRequest?.params?.query === '' && !hasSearched) {
      hasSearched = true;
      return Promise.resolve();
    }
    return algoliaClient.search(requests);
  },
};

export default searchClient;
